
module.exports = {
    language_title:'Select your language',
    language:'English',
    company:'Company Information',
    address:'Address',
    service_tel:'Service Tel',
    operator:'Operator',
    complaint_tel:'Complaint Tel',
    email:'Email',
    submit:'submit',
    submiting:'Submitting',
    weTeamList:'Our Leadership Team',
    must_import:'Please enter must enter',
    scoll:'Scroll to',
    more:'find more',
    mores:'more',
    name:'Name',
    number:'Number of Guests',
    phone:' Phone Number',
    event:'Event destination',
    request:'Your request',
    privacy:'Privacy Statement',
    explain:'Mandarin collects your personal data to process your request and respond to you.For more information',
    country:'China',
    project:'projects',
    guests:'guests',
    submit_success:'Submit succeeded',
    detail:'Detailed consultation'
}
   


// WEBPACK FOOTER //
// ./src/i18n/en_us.js